// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".versioning-box[data-v-01dd00ca]{display:flex;width:100%;z-index:1}.versioning-box__versioning-item-container[data-v-01dd00ca]{position:relative;border-bottom:1px solid var(--v-gray-pale);background-color:var(--versioning-item-color)}.versioning-box[data-v-01dd00ca] .btn-icon-septim:disabled *{opacity:1;fill:var(--v-gray-light)}", ""]);
// Exports
module.exports = exports;
